export default [
	{  // 【知识专区】-【Banner】
		path: 'website/knowledge/banner',
		name: 'm_knowledge_banner',
		meta: {
			title: '知识专区Banner'
		},
		component: () => import('@/pages/website/knowledge/knowledge_banner')
	},
	{  // 【知识专区】-【标准品100讲】
		path: 'website/knowledge/lectures',
		name: 'm_lectures',
		meta: {
			title: '标准品100讲'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/lectures_list')
	}, {  // 【知识专区】-【张博士谈标准品】
		path: 'website/knowledge/standard',
		name: 'm_standard_substance',
		meta: {
			title: '张博士谈标准品'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/standard_substance_list')
	},{  // 【知识专区】-【张博士谈标准品】
		path: 'website/knowledge/standard',
		name: 'm_standard_substance',
		meta: {
			title: '阿尔塔有约'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/standard_substance_list')
	},{  // 【知识专区】-【阿尔塔有约】
		path: 'website/knowledge/aerta_date',
		name: 'm_aerta_date_list',
		meta: {
			title: '阿尔塔有约'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/aerta_date_list')
	},{  // 【知识专区】-【标物小百科】
		path: 'website/knowledge/encyclopedia',
		name: 'm_encyclopedia_list',
		meta: {
			title: '标物小百科'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/encyclopedia_list')
	},{  // 【知识专区】-【热点检测】
		path: 'website/knowledge/testing',
		name: 'm_hot_testing',
		meta: {
			title: '热点检测'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/testing_list')
	},{  // 【知识专区】-【论文成果】
		path: 'website/knowledge/paper',
		name: 'm_paper',
		meta: {
			title: '论文成果'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/knowledge/paper_list')
	},


	{  // 【知识专区】-【标准品100讲】
		path: 'website/knowledge/lectures/en',
		name: 'm_lectures_en',
		meta: {
			title: '标准品100讲'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/lectures_list')
	}, {  // 【知识专区】-【张博士谈标准品】
		path: 'website/knowledge/standard/en',
		name: 'm_standard_substance_en',
		meta: {
			title: '张博士谈标准品'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/standard_substance_list')
	},{  // 【知识专区】-【张博士谈标准品】
		path: 'website/knowledge/standard/en',
		name: 'm_standard_substance_en',
		meta: {
			title: '阿尔塔有约'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/standard_substance_list')
	},{  // 【知识专区】-【阿尔塔有约】
		path: 'website/knowledge/aerta_date/en',
		name: 'm_aerta_date_list_en',
		meta: {
			title: '阿尔塔有约'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/aerta_date_list')
	},{  // 【知识专区】-【标物小百科】
		path: 'website/knowledge/encyclopedia/en',
		name: 'm_encyclopedia_list_en',
		meta: {
			title: '标物小百科'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/encyclopedia_list')
	},{  // 【知识专区】-【热点检测】
		path: 'website/knowledge/testing/en',
		name: 'm_hot_testing_en',
		meta: {
			title: '热点检测'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/testing_list')
	},{  // 【知识专区】-【论文成果】
		path: 'website/knowledge/paper/en',
		name: 'm_paper_en',
		meta: {
			title: '论文成果'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/knowledge/paper_list')
	}
];